import { FunctionComponent } from 'react'

import { Flex, Image } from '@theme-ui/components'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import {
  baseColors,
  makeTransition,
  Text,
  TickCircleFilled,
} from '@fairhq/common'

import { useAreaProgress } from 'features/assessmentQuestions/hooks/useAreaProgress'
import { TickThin } from 'features/reportsEqualityAreas/TickThin'
import RouterLink from 'ui-kit/RouterLink'

const StyledRouterLink = styled(RouterLink)`
  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`

export const SubArea: FunctionComponent<{ code: string; label: string }> = ({
  code,
  label,
}) => {
  const { completed, total } = useAreaProgress({ area: { code } })
  const { t } = useTranslation()

  return (
    <Flex
      sx={{
        bg: 'white',
        border: `1px solid ${baseColors.borderBackground}`,
        borderRadius: 4,
        padding: '20px 32px 20px 132px',

        alignItems: 'center',
        justifyContent: 'space-between',
        color: baseColors.contentContent,
        transition: makeTransition('color'),
        position: 'relative',
        lineHeight: '24px',
        overflow: 'hidden',
      }}
    >
      <Image
        src={t(`${code}.image`)}
        alt=""
        sx={{
          height: '90px',
          width: '90px',
          position: 'absolute',
          top: '0',
          left: '21px',
        }}
      />
      <StyledRouterLink to={`/assessment/${code}`}>
        <Text element="span" size="sm" fontWeight={600} type="body">
          {label}
        </Text>
      </StyledRouterLink>
      <Flex sx={{ alignItems: 'center', gap: '8px', svg: { flexShrink: 0 } }}>
        <Text
          element="span"
          size="sm"
          fontWeight={700}
          type="body"
          color={baseColors.contentMuted}
        >
          {completed}/{total}
        </Text>
        {completed >= total ? (
          <TickCircleFilled outline={baseColors.boldActionSuccess} />
        ) : (
          <TickThin width="20" height="20" fill="transparent" />
        )}
      </Flex>
    </Flex>
  )
}
